export declare namespace AppModalTokenSections {
	interface Header {
		color: string;
		fontSize: string;
		lineHeight: string;
		fontWeight: string;
		closeIcon: {
			fontSize: string;
			color: string;
			fontWeight: string;
		};
		title: {
			color: string;
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
		};
		subtitle: {
			fontSize: string;
			lineHeight: string;
		};
	}

	interface Content {
		color: string;
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
		padding: string;
		header: {
			color: string;
			fontSize: string;
			lineHeight: string;
		};
	}
}

export type AppModalTokens = {
	header: AppModalTokenSections.Header;
	content: AppModalTokenSections.Content;
};

export const header: AppModalTokenSections.Header = {
	color: '{surface.600}',
	fontSize: '0.75rem',
	lineHeight: '1.25rem',
	fontWeight: '500',
	closeIcon: {
		fontSize: '1.5rem',
		color: '{surface.500}',
		fontWeight: '500',
	},
	title: {
		color: '{text.color}',
		fontSize: '1.25rem',
		lineHeight: '1.75rem',
		fontWeight: '600',
	},
	subtitle: {
		fontSize: '0.75rem',
		lineHeight: '1.25rem',
	},
};

export const content: AppModalTokenSections.Content = {
	color: '{overlay.modal.body.color}',
	fontWeight: '500',
	fontSize: '1rem',
	lineHeight: '1.625rem',
	padding: '0px',
	header: {
		color: '{text.color}',
		fontSize: '1.5rem',
		lineHeight: '2rem',
	},
};

export default {
	header,
	content,
} satisfies AppModalTokens;
